import * as React from 'react';
import { Group } from '@mantine/core';
import { StandardsStructureComponent } from './structure/StandardsStructureComponent';
import { UseCasesStructureComponent } from './structure/UseCasesStructureComponent';
import { WorkflowRepresentationsStructureComponent } from './structure/WorkflowRepresentationsStructureComponent';
import { useParams } from 'react-router-dom';
import { useMyNavigate } from '../../router/createdRouter';
import { useUserId } from '../../authentication/useUserId';
import { useUserActions } from '../../../resource/resources/persistables/user/userResource';
import {
    useProjectVersionPublishmentActions
} from '../../../resource/resources/artifacts/project/projectVersionPublishmentResource';

export const ProjectStructureComponent= ({ projectId, projectVersionId }: {
    projectId: string | undefined,
    projectVersionId: string | undefined
}) => {
    const { standardId, useCaseId } = useParams<{ standardId: string, useCaseId: string }>();
    const navigate = useMyNavigate();

    const [selectedStandardObjectId, setSelectedStandardObjectId] = React.useState<string>(standardId ?? '');
    const [selectedUseCaseId, setSelectedUseCaseId] = React.useState<string>(useCaseId ?? '');

    const userId = useUserId('');

    const userActions = useUserActions()
    const projectVersionPublishmentActions = useProjectVersionPublishmentActions();
    const userSystemRights = userActions.useGetUserEffectiveRightsOfUser(userId, projectId);
    const projectVersionPublishment = projectVersionPublishmentActions.useGetSingleResource(projectVersionId);
    const isProcessAdmin = userSystemRights.data?.isProcessAdmin;

    return (
        <Group grow h={isProcessAdmin ? (projectVersionPublishment.data ? 'calc(100vh - 370px)' : 'calc(100vh - 320px)') : (projectVersionPublishment.data ? 'calc(100vh - 290px)' : 'calc(100vh - 240px)')} pt={4}>
            <StandardsStructureComponent
                projectVersionId={projectVersionId}
                onSelected={(id) => {
                    setSelectedUseCaseId('');
                    setSelectedStandardObjectId(id);
                }} />
            <UseCasesStructureComponent
                projectVersionId={projectVersionId}
                standardObjectId={selectedStandardObjectId}
                onSelected={(id) => {
                    setSelectedUseCaseId(id);
                }}
                onOpen={(id) => {
                    history.replaceState('content', 'title', `/project/${projectId}/active-version/${projectVersionId}/standard/${selectedStandardObjectId}/use-case/${selectedUseCaseId}`);
                    navigate({
                        route: '/project/:id/active-version/:versionId/standard/:standardId/use-case/:useCaseId/workflow-representations',
                        routeParams: {
                            id: projectId ?? '',
                            versionId: projectVersionId ?? '',
                            standardId: selectedStandardObjectId,
                            useCaseId: id,
                        },
                        searchParams: {},
                    });
                }}
            />
            <WorkflowRepresentationsStructureComponent
                projectVersionId={projectVersionId}
                useCaseId={selectedUseCaseId}
                onOpen={(id) => {
                    history.replaceState('content', 'title', `/project/${projectId}/active-version/${projectVersionId}/standard/${selectedStandardObjectId}/use-case/${selectedUseCaseId}`);
                    navigate({
                        route: '/project/:id/active-version/:versionId/standard/:standardId/use-case/:useCaseId/workflow-representations',
                        routeParams: {
                            id: projectId ?? '',
                            versionId: projectVersionId ?? '',
                            standardId: selectedStandardObjectId,
                            useCaseId: selectedUseCaseId,
                        },
                        searchParams: { selected: id },
                    });
                }}
            />
        </Group>
    );
};